/**
 * Trefferzeile der Projektsuche in der Kommandopalette (Issue #62), rein und testbar.
 *
 * Form (einzeilig, bindend): `P900123 · Müller AG — S/4HANA Conversion Vorstu…`
 * Das Segment gehört NICHT ins Label — es bleibt der Hint rechts in der Zeile.
 *
 * Warum ein Zeichenbudget UND CSS-Ellipse: das Palettenfenster ist 560px breit, die
 * Zeile teilt sich den Platz mit dem Segment-Hint. Das Budget kürzt gezielt die
 * Bezeichnung (Nummer und Kunde bleiben dadurch immer vollständig lesbar); die
 * CSS-Ellipse in der Zeile selbst fängt nur den Rest ab, wenn ein sehr langer
 * Kundenname die Zeile trotzdem überlaufen lässt.
 */
export type ProjectSearchHit = {
  project_key: string;
  customer_name: string;
  name: string;
};

/** Zeichenbudget der Projektbezeichnung in der Trefferzeile (inkl. Ellipse). */
export const PROJECT_LABEL_NAME_MAX = 40;

function truncate(value: string, max: number): string {
  if (value.length <= max) return value;
  return `${value.slice(0, max - 1).trimEnd()}…`;
}

export function formatProjectSearchLabel(hit: ProjectSearchHit): string {
  const key = hit.project_key.trim();
  const customer = hit.customer_name.trim();
  const name = hit.name.trim();

  const head = customer.length > 0 ? `${key} · ${customer}` : key;
  // Der Trenner gehört nur zur Zeile, wenn es eine Bezeichnung gibt — sonst stünde er
  // einsam am Ende.
  return name.length > 0 ? `${head} — ${truncate(name, PROJECT_LABEL_NAME_MAX)}` : head;
}
